import { default as getConfiguration } from './get';
import { default as getDashboardContentConfiguration } from './getDashboardContent';
import { default as getDashboardEventConfiguration } from './getDashboardEvent';
import { default as getRecommendedConfiguration } from './getRecommended';
import { default as loadMoreConfiguration } from './loadMore';

export const configurations = [
  getConfiguration,
  getRecommendedConfiguration,
  getDashboardContentConfiguration,
  getDashboardEventConfiguration,
  loadMoreConfiguration
]


// WEBPACK FOOTER //
// ./src/state/modules/search-tile/configurations/index.js